'use client';

import "@/lib/apiInterceptor";
import { LanguageProvider } from "@/context/LanguageContext";
import AuthGuard from "@/components/Auth/AuthGuard";

export function Providers({ children }: { children: React.ReactNode }) {
  return (
    <LanguageProvider>
      <AuthGuard>
        {children}
      </AuthGuard>
    </LanguageProvider>
  );
}
